<script context="module" lang="ts">
	// your script goes here
	export type SaveDetail = {
		id: string;
		title: string;
		linkUrl: string;
		documentState: string;
		image: string;
	};
</script>

<script lang="ts">
	//UI
	import {
		Card,
		SlotSelect,
		DefaultButton,
		AdaptiveTextInput,
	} from "@hitit/new_ui";
	//Utils
	import { t } from "@hitit/hub/src/stores";
	import ThumbnailImage from "../HubSetting/ThumbnailImage.svelte";
	import { createEventDispatcher } from "svelte";
	//Types
	import type { PostDTO } from "@hitit/api";
	//Props
	export let item: PostDTO;
	export let newItem: boolean = false;
	//Constants
	
	const dispatch = createEventDispatcher();
	const selectOptions = ["OBSOLETE", "PUBLISHED", "DRAFT"].map((v) => ({
		label: v,
		value: v,
		display: v,
	}));
	//Variables
	let receivedOrigin : PostDTO
	let targetPostDTO : PostDTO
	
	//Functions
	function saveHandler() {
		dispatch("SAVE",targetPostDTO);
	}

	function init(item: PostDTO) {
		if (receivedOrigin !== undefined && item.id === receivedOrigin.id) return;

		receivedOrigin = Object.assign({}, item)
		targetPostDTO = Object.assign({},item)
	}
	//Do
	$: init(item);
	$: samePropertyCondition = JSON.stringify(receivedOrigin) === JSON.stringify(targetPostDTO);
	$: emptyPropertyCondition = ((target : PostDTO) => {
		const { image , title, linkUrl} = target;
		return !image || !title || !linkUrl
	})(targetPostDTO)
	$: saveDisabled = samePropertyCondition || emptyPropertyCondition
	
</script>

<div class="container" id="single-editor">
	<Card noPadding>
		<div class="content-wrapper">
			<div class="status-box">
				<div class="thumbnail-box">
					<ThumbnailImage newitem={newItem} bind:imageaddr={targetPostDTO.image} />
				</div>
				<div class="status">
					<SlotSelect
						bind:value={targetPostDTO.documentState}
						-select
						svg
						backgroundColor="#f0f0f4"
						items={selectOptions}
						let:displayValue
					>
						<div class="select-inner">
							<span
								class="icon"
								class:publish={displayValue === "PUBLISHED"}
								class:obsolate={displayValue === "OBSOLETE"}
							/>

							<span class="value"> {displayValue} </span>
						</div>
					</SlotSelect>
				</div>
			</div>
			<div class="name-value">
				<div class="title">{$t("mbr.setting.post_setting.title")}</div>
				<AdaptiveTextInput -post-input={true} bind:value={targetPostDTO.title} />
			</div>
			<div class="name-value">
				<div class="title">{$t("mbr.setting.post_setting.connect_url")}</div>
				<AdaptiveTextInput -post-input={true} bind:value={targetPostDTO.linkUrl} />
			</div>
			<DefaultButton
				on:click={saveHandler}
				-post-save={true}
				disabled={saveDisabled}
			>
				<span class="save"> 임시저장 </span>
			</DefaultButton>
		</div>
	</Card>
</div>

<style lang="scss">
	@import "../../../variables.scss";

	.container {
		width: 100%;

		:global(.-post-input) {
			color: #46474b;
			background-color: #f0f0f4 !important;
			font-weight: 200 !important;
			font-size: 1rem;
			height: 30px;
		}
		:global(.-post-save) {
			display: flex;
			justify-content: center;
			align-items: center;
			height: 33px;
		}

		:global(.filter-option) {
			gap: unset;
		}
	}
	.content-wrapper {
		display: flex;
		flex-direction: column;
		width: 100%;
		padding: 20px 10px 80px 10px;
		gap: 20px;

		.status-box {
			display: flex;
			justify-content: space-between;
			align-items: flex-start;
			flex-direction: column;
			gap: 10px;
		}

		.thumbnail-box {
			order: 2;
		}

		.status {
			display: flex;
			gap: 10px;
			color: #46474b;
			font-weight: 200;
			width: 153px;
			height: 32px;
			order: 1;
			:global(.-select) {
				padding: 10px;
			}
			.select-inner {
				display: flex;
				gap: 10px;
				align-items: center;
				flex-grow: 1;

				.icon {
					width: 15px;
					height: 15px;
					border-radius: 15px;
					background-color: #bcbfc3;

					&.publish {
						background-color: #44e4ae;
					}

					&.obsolate {
						background-color: #ffce00;
					}
				}
				.value {
					margin-top: -1px;
				}
			}
		}

		.name-value {
			display: flex;
			flex-direction: column;
			gap: 10px;

			.title {
				font-size: 1rem;
				font-weight: 300;
			}

			.value {
				width: 100%;
			}
		}
	}
	.save {
		font-size: 1rem;
		font-weight: 500;
		color: white;
		margin-top: -2px;
	}

	@include DesktopSize {
		.container {
			:global(.-post-input) {
				font-size: 1.25rem;
				height: 40px;
			}
			:global(.-post-save) {
				height: 40px;
			}
		}
		.content-wrapper {
			padding: 30px;

			.status-box {
				flex-direction: row;
			}

			.thumbnail-box {
				order: unset;
			}

			.status {
				font-size: 1.25rem;
				width: 183px;
				height: 40px;
				order: unset;
				.select-inner {
					.icon {
						width: 20px;
						height: 20px;
						border-radius: 20px;
					}
					.value {
						margin-top: -2px;
					}
				}
			}
		}
		.save {
			font-size: 1.25rem;
		}
	}
</style>
